<template>
  <div>
    <transition name="fadeslide">
      <div class="_loader" v-if="$root.is_loading">
        <span class="loader loader-quart"></span>
        Chargement…
      </div>
    </transition>
    <transition name="fadeslide">
      <div id="app" v-if="!$root.is_loading">
        <header>
          <Bandeau />
        </header>
        <main class>
          <section class="m_parcours">
            <header class="m_parcours--entete" v-if="$root.copy_content.parcours">
              <div
                v-html="
                `<span class='_excerpt'>PARCOURS —</span
            >${$root.copy_content.parcours}`
              "
              />
            </header>
            <div class="m_parcours--taglist" v-if="Object.keys(taglist).length > 0">
              <p>Filtrer par mots-clés&nbsp;:</p>

              <button
                type="button"
                class="m_parcours--taglist--tag"
                :class="{ 'is--active': tag === keyword_filter }"
                v-for="(count, tag) in taglist"
                :key="tag"
                @click="toggleFilter(tag)"
              >
                {{ tag }}
                <span class="m_parcours--taglist--tag--count">
                  <small>{{ count }}</small>
                </span>
              </button>
            </div>

            <div class="m_parcours--publications">
              <transition-group name="list-complete">
                <Publication
                  v-for="(publication, index) in sorted_recipes"
                  :key="index"
                  :publication="publication"
                />
              </transition-group>
            </div>
          </section>
        </main>

        <PublicationModal
          v-if="$root.current_publication_opened"
          :publication="$root.current_publication_opened"
          @close="$root.state.modal.current_publication_slug = false"
        />
        <footer class="m_footer">
          <span v-html="$root.copy_content.footer" />
        </footer>
      </div>
    </transition>
  </div>
</template>

<script>
import Bandeau from "./components/Bandeau.vue";
import Publication from "./components/Publication.vue";
import PublicationModal from "./components/PublicationModal.vue";

export default {
  name: "app",
  components: {
    Bandeau,
    Publication,
    PublicationModal
  },
  data() {
    return {
      keyword_filter: false
    };
  },
  mounted() {},
  computed: {
    sorted_recipes() {
      return this.$root.recipes_of_this_template.filter(
        r =>
          !this.keyword_filter ||
          (this.keyword_filter &&
            r.keywords &&
            r.keywords.some(k => k.title === this.keyword_filter))
      );
    },
    taglist() {
      return this.$root.recipes_of_this_template.reduce((acc, r) => {
        if (!Array.isArray(r.keywords) || r.keywords.length === 0) return acc;

        r.keywords.map(k => {
          !acc.hasOwnProperty(k.title)
            ? (acc[k.title] = 1)
            : (acc[k.title] += 1);
        });

        return acc;
      }, {});
    }
  },
  methods: {
    toggleFilter(tag) {
      if (this.keyword_filter === tag) this.keyword_filter = false;
      else this.keyword_filter = tag;
    }
  }
};
</script>

<style lang="scss">
:root {
  --background-color: #fff;
  --logo-blue: #52c5b9;
  --logo-blue_lighter: #47998d;
  --logo-blue_lighterer: #f4f3ef;
  --logo-red: #fc4b60;
  --color-green: #52c5b9;
  --color-gray: #f2f2f2;
  --spacing: 1rem;

  // @c-bleumarine: #1d327f;
  // @c-bleuvert: #52c5b9;
  // @c-orange: #ffbe32;
  // @c-rouge: #fc4b60;

  // @c-bleumarine_clair: #bec6e5;
  // @c-bleuvert_clair: #a5e5da;
  // @c-orange_clair: #ffd892;
  // @c-rouge_clair: #ff808c;

  // @c-bleumarine_fonce: #12224c;
  // @c-bleuvert_fonce: #47998d;
  // @c-orange_fonce: #d19833;
  // @c-rouge_fonce: #cc334a;

  // @c-blanc: #fff;
  // @c-creme: #f4f3ef;
  // @c-gris: #b9b9b9;
  // @c-gris_clair: #e5e5e5;
  // @c-gris_tresclair: #f1f1f1;
  // @c-gris_fonce: #666666;
  // @c-noir: #353535;
}
html {
  // scroll-behavior: smooth;
}

body {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  background-color: var(--background-color);
  color: var(--text-color);
  margin: 0;

  font-size: 1.1rem;
  line-height: 1.4;
}

#app {
  margin-top: calc(var(--spacing) * 3);
  padding: 0 var(--spacing);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

hr {
  width: 2em;
  margin-left: 0;
  border: none;
  border-top: 1px solid #ccc;
}

button,
.button,
label,
.label {
  font-family: inherit;
  padding: 4px 6px;
  border-radius: 2px;
  font-weight: 400;
  font-size: 0.8em;
  cursor: pointer;

  color: white;
  background-color: var(--logo-blue);

  box-decoration-break: clone;

  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);

  svg {
    color: #fff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

a {
  color: var(--logo-blue) !important;
}

label {
  appearance: none;
  color: var(--logo-blue);
  background-color: transparent;
}

button,
.button {
  appearance: none;
  border: 0;
  background-color: var(--logo-blue);
  color: white;
  border-radius: 4px;
  line-height: 1;
  padding: calc(var(--spacing) / 2);
  display: inline-flex;

  &:hover,
  &:active,
  &:focus,
  &.is--active {
    &:not([disabled]) {
      background-color: var(--logo-blue_lighter);
      outline: 0;
    }
  }
}

.m_footer {
  max-width: 600px;
  margin: calc(var(--spacing) * 6) auto 0;
  text-align: center;
  font-size: 80%;
}

main {
  max-width: 1200px;
  padding: 0 var(--spacing);
  width: 100%;
  margin: 0 auto;
}

p {
  font-family: "Alegreya", Georgia, serif;
}

.m_parcours {
  // max-width: 1200px;
  width: 100%;
  // padding: 0 1em;
  margin: 0 auto;

  .m_parcours--entete {
    // border-top: 2px solid var(--logo-red);
    // border-bottom: 2px solid var(--logo-red);

    margin: var(--spacing) 0 var(--spacing);
    padding: var(--spacing) 0;

    > * {
      // display: inline-block;
    }

    p {
      margin: 0;
    }

    ._excerpt {
      color: var(--logo-red);
      font-family: "Fira Sans";
      font-weight: 500;
      margin-right: 0.5em;

      + p {
        display: inline;
      }
    }
  }

  .m_parcours--taglist {
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
    border-bottom: 2px solid var(--logo-blue);
    padding-bottom: calc(var(--spacing) * 0.5);
    margin-bottom: calc(var(--spacing) * 2);

    > * {
      display: inline-block;
    }

    .m_parcours--taglist--tag {
      margin: 0 calc(var(--spacing) / 2) calc(var(--spacing) / 2)
        calc(var(--spacing) / 2);

      .m_parcours--taglist--tag--count {
        background-color: var(--logo-blue_lighter);
        border-radius: 50%;
        width: 1em;
        height: 1em;
        display: inline-block;
      }
    }
  }

  .m_parcours--publications {
    > span {
      position: relative;
      display: grid;
      grid-gap: var(--spacing);
      grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));

      > * {
        position: relative;
      }
    }
  }
}

._loader {
  position: fixed;
  width: 100%;
  height: 100%;
  color: #333;

  font-size: 100%;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  --spinner-size: 20px;
  --spinner-border: 2px;

  // font-family: "Roboto Mono";
  text-transform: uppercase;
  font-weight: 300;
  padding-bottom: 2em;
}

.loader {
  position: relative;
  display: inline-block;
  width: var(--spinner-size);
  height: var(--spinner-size);
  vertical-align: middle;

  margin-right: 0.5em;
}

/*	$Loader Quadrant
	========================================================================== */

.loader-quart {
  border-radius: var(--spinner-size);
  border: var(--spinner-border) dotted rgba(51, 51, 51, 0.2);
}

.loader-quart:after {
  content: "";
  position: absolute;
  top: calc(-1 * var(--spinner-border));
  left: calc(-1 * var(--spinner-border));
  bottom: calc(-1 * var(--spinner-border));
  right: calc(-1 * var(--spinner-border));
  border-radius: var(--spinner-size);
  border: var(--spinner-border) solid transparent;
  border-top-color: #333;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.svg-icon {
  width: 2em;
  height: 2em;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: currentColor;
}

.svg-icon circle {
  stroke: currentColor;
  stroke-width: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fadeslide-enter-active,
.fadeslide-leave-active {
  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
.fadeslide-enter,
.fadeslide-leave-to {
  opacity: 0;
  transform: translateY(15px);
}

.list-complete-move {
  position: relative;
  transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
}
.list-complete-leave-active {
  position: absolute;
  z-index: 0 !important;
}

.ListView-enter-active,
.ListView-leave-active {
  opacity: 1;
  transform: scale(1);
  transform-origin: center center;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
.ListView-enter,
.ListView-leave-to {
  opacity: 0;
  transform: scale(0.96);
}
</style>
